module.exports = __webpack_public_path__ + "img/bri_va.98769537.svg";